/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Support_Reply_1Inputs */

const en_wb_support_reply_1 = /** @type {(inputs: Wb_Support_Reply_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hi! We have openings at 10:00 and 14:30 this Saturday. The initial consultation is €65 and takes about 45 minutes.`)
};

const lv_wb_support_reply_1 = /** @type {(inputs: Wb_Support_Reply_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sveiki! Šosestdien ir brīvi laiki plkst. 10:00 un 14:30. Pirmā konsultācija maksā 65 € un ilgst aptuveni 45 minūtes.`)
};

/**
* | output |
* | --- |
* | "Hi! We have openings at 10:00 and 14:30 this Saturday. The initial consultation is €65 and takes about 45 minutes." |
*
* @param {Wb_Support_Reply_1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_support_reply_1 = /** @type {((inputs?: Wb_Support_Reply_1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Support_Reply_1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_support_reply_1(inputs)
	return en_wb_support_reply_1(inputs)
});